import { UiLogicModules } from '../../../../infrastructure/types/models/UiLogicModules';
import React, { ReactElement } from 'react';
import { UILogicContext } from './context';

interface UIModulesProps {
  children: React.ReactNode;
  uiModules: UiLogicModules;
}

function UILogicProvider({ children, uiModules }: UIModulesProps): ReactElement {
  return <UILogicContext.Provider value={uiModules}>{children}</UILogicContext.Provider>;
}

export { UILogicProvider };
